<template>
    <div>
        <el-dialog :visible.sync="showBox" width="520px" title="加速回收" @close="closeModal">
            <div class="modal_area">
                <el-row class="tips">
                    <el-col :span="2">
                        <img src="https://image.shoukala.com/image/shoukala_new/huishou_warning.png" alt="">
                    </el-col>
                    <el-col :span="22">
                        <p>系统根据“低价优先”的规则进行充值卡回收</p>
                        <p>当前您的卡可能定价过高，可以选择降价，加快回收的速度。</p>
                    </el-col>
                </el-row>

                <el-row class="info">
                    <el-col :span="2">
                        <span class="icon"></span>
                    </el-col>
                    <el-col :span="22" :offset="2">
                        <p>降价卡产品: <span>{{cardinfo.face_value}}元 - {{cardinfo.name}} - {{cardinfo.province_name}} / ({{cardinfo.total}}张)</span></p>
                        <p v-if="type=='order'">降价货单号: <span>{{cardinfo.order_id}}</span></p>
                        <p v-if="type=='card'">卡号: <span>{{cardinfo.card_no}}</span></p>
                    </el-col>
                </el-row>

                <el-row class="info">
                    <el-col :span="2">
                        <span class="icon"></span>
                    </el-col>
                    <el-col :span="22" :offset="2">
                        <p>请输入4位折扣<span class="discount_tips">（降价折扣低于之前折扣才能生效） </span></p>
                        <discount-input ref="discountComp" :discount="cardinfo.discount" :unitprice="cardinfo.face_value" :showtext="false" @update:discount="getNewDiscount" style="margin-top:10px"></discount-input>
                    </el-col>
                </el-row>
                <el-row class="info">
                    <el-col :span="22" :offset="2">
                        <el-button type="primary" @click="submitDiscount">降价提交</el-button>
                    </el-col>
                </el-row>
            </div>
            
            <p slot="footer"></p>
        </el-dialog>
    </div>  
</template>

<script>
import discountInput from './discountInput';
import {changeDiscount} from '@/api/userinfo.js';
export default {
    data(){
        return{
            saleDiscount:'',
            province_name: ''
        }
    },
    components:{
        discountInput
    },
    props:{
        //降价的是单号还是卡号
        type:{
            type: String,
            default: 'order'
        },
        //卡信息
        cardinfo:{
            type: Object,
            default: {}
        },
        // 弹窗显示
        modalShow:{
            type:Boolean,
            default: false
        }
    },
    computed:{
        //展示弹窗
        showBox:{
            get: function() {
                return this.modalShow
            },
            set: function() {
            }
        },
    },
    methods:{        
        //关闭弹窗
        closeModal(){
            this.$emit('update-show',false);
        },
        //清除折扣输入
        clearDiscount(){
            if(this.$refs['discountComp']) {
                this.$refs['discountComp'].clearDiscount();
            }
        },

        //获取新折扣
        getNewDiscount(newDiscount){
            this.saleDiscount = newDiscount;
        },

        //提交降价
        submitDiscount(){
            this.$refs.discountComp.sendNewDiscount();
            if(this.saleDiscount.length<4){
                 this.$message.warning('折扣必须填写满四位!');
            }
            else{
                let submitData;
                if(this.type == 'order'){
                    submitData = {
                        'order_id': this.cardinfo.order_id,
                        'discount': this.saleDiscount
                    }
                    changeDiscount(submitData).then(res => {
                        if(res.data.code == '100001'){
                            this.$emit('changeSuccess',res)
                        }

                    })
                }
                if(this.type == 'card'){
                    submitData = {
                        'card_id': this.cardinfo.id,
                        'discount': this.saleDiscount
                    }
                    changeDiscount(submitData).then(res => {
                        if(res.data.code == '100001'){
                            this.$emit('changeSuccess',res)
                        }

                    })
                }
                    
            }
        }

    }
    
}
</script>

<style scoped lang="scss">
.modal_area{
    width:360px;
    margin: 0px auto;
    .tips{
        img{
            margin-top: 4px;
        }
        p{
            color: #999999;
            line-height: 18px;
        }
    }
    .info{
        margin: 15px 0;
        .icon:after{
            content:'';
            background: var(--color);
            width:6px;
            height:6px;
            border-radius: 5px;
            top: 8px;
            display: block;
            left: 8px;
            position: absolute;
        }
        p{
            font-weight: bold;
            color:#666666;
            span{
                font-weight: normal;
                margin-left:4px;
            }
            .discount_tips{
                color: #CCCCCC;
                font-size: 12px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/discountModal.vue